import { Alert, Stack } from '@mui/material';
import mixpanel from 'mixpanel-browser';
import { FC, useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { Loader } from '../../components/Loader/Loader';
import GlobalContext from '../../contexts/GlobalContext';
import ThirdPartyLoginContext, {
    EThirdPartyLoginUiState,
    ThirdPartyLoginProvider,
} from '../../contexts/ThirdPartyLoginContext';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { EMixpanelEvent, ERoutes } from '../../util/constants';

const ThirdPartyLoginUi: FC = () => {
    const { fullLoginLink, language } = useContext(GlobalContext);
    const { thirdPartyLoginUiState, userId, loginProvider } = useContext(ThirdPartyLoginContext);

    const handleLogin = () => {
        userId && mixpanel.identify(userId);
        mixpanel.track(EMixpanelEvent.actionCompleted, {
            key: 'consumer_signin',
            ...(loginProvider && { provider: loginProvider }),
        });
        window.location.assign(fullLoginLink);
    };
    switch (thirdPartyLoginUiState) {
        case EThirdPartyLoginUiState.default:
            return (
                <PageLayoutV2 showFooter={false}>
                    <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                        <Loader />
                    </Stack>
                </PageLayoutV2>
            );
        case EThirdPartyLoginUiState.ready:
            return (
                <>
                    <PageLayoutV2 showFooter={false}>
                        <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                            <Loader />
                        </Stack>
                    </PageLayoutV2>
                    {fullLoginLink ? (
                        handleLogin()
                    ) : (
                        <>
                            {console.error('No login link in third party login context')}
                            <Redirect to={ERoutes.login} />
                        </>
                    )}
                </>
            );
        default:
            console.error('Third party login state set incorrectly');
            return <Alert severity="error">{language.error.generic}</Alert>;
    }
};

const ThirdPartyLoginScreen: FC = () => {
    return (
        <ThirdPartyLoginProvider>
            <ThirdPartyLoginUi />
        </ThirdPartyLoginProvider>
    );
};

export default ThirdPartyLoginScreen;
